/**
 * CUSTOM FEATURED INSERT MODAL SCRIPT
 * ------------------------------------
 * Handles modal open/close for the Featured Insert cards on collection pages.
 *
 * Functionality:
 * - Opens modal when "View Details" button is clicked
 * - Closes modal on "Close" button click
 * - (Bonus ideas: ESC key closes modal, click outside modal closes it, focus trap — can be added later)
 *
 * Where styles are defined:
 * - Styling for modals and cards: /assets/final-theme.css (or your main stylesheet)
 * - Classes: .custom-featured-insert-modal, .custom-featured-insert-modal-content, etc.
 *
 * Notes:
 * - This JS file is located in /assets/custom-featured-insert-modal.js
 * - Keep modal markup in custom-featured-insert-grid.liquid
 */

document.addEventListener('DOMContentLoaded', function () {
  // Handle "View Details" buttons
  const viewButtons = document.querySelectorAll('.custom-featured-insert-button');

  viewButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const modalId = button.getAttribute('data-insert-id');
      const modal = document.getElementById(modalId);

      if (modal) {
        // Close any open modals first (optional safety)
        document.querySelectorAll('.custom-featured-insert-modal.active').forEach((openModal) => {
          openModal.classList.remove('active');
        });

        // Show this modal
        modal.classList.add('active');
      }
    });
  });

  // Handle chase card "View Details" button clicks
  const chaseButtons = document.querySelectorAll('.chase-card-button[data-insert-id]');

  chaseButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const modalId = button.getAttribute('data-insert-id');
      const modal = document.getElementById(modalId);

      if (modal) {
        document.querySelectorAll('.custom-featured-insert-modal.active').forEach((openModal) => {
          openModal.classList.remove('active');
        });
        modal.classList.add('active');
      }
    });
  });

  const closeButtons = document.querySelectorAll('.custom-featured-insert-modal-close');

  closeButtons.forEach((closeBtn) => {
    closeBtn.addEventListener('click', function () {
      const modal = closeBtn.closest('.custom-featured-insert-modal');
      if (modal) {
        modal.classList.remove('active');
      }
    });
  });

  // OPTIONAL: click outside to close (if modal is inside card/container)
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.custom-featured-insert-modal.active').forEach((modal) => {
      if (
        !modal.contains(e.target) &&
        !e.target.classList.contains('custom-featured-insert-button') &&
        !e.target.classList.contains('chase-card-button')
      ) {
        modal.classList.remove('active');
      }
    });
  });
});
